<template>
	<form action="" class="form" @submit.prevent="submit" novalidate="true">
		<div class="form-control">
			<label for="email" class="form-label">Электронная почта</label>
			<input v-model="login" class="form-input" type="text" name="email" id="email" />
			<label v-if="isValid && !login" class="error">Это поле обязательно</label>
			<label class="error" v-if="isValid && !idn">Не верный формат электронной почты</label>
			<label class="error" v-if="isValid && idn && !domainAllowed">
				Домен «{{ domain }}» нельзя использовать для регистрации
			</label>
		</div>
		<div class="form-control">
			<label for="phone" class="form-label">Телефон</label>
			<phone-mask-input
				v-model="phone"
				wrapperClass="form-wrapper"
				inputClass="form-input"
				id="phone"
				autoDetectCountry
			/>
			<label v-if="isValid && (!phone || phone.length <= 5)" class="error">Это поле обязательно</label>
		</div>
		<div class="form-control">
			<label for="name" class="form-label">Ваше имя</label>
			<input v-model="name" class="form-input" type="text" name="name" id="name" />
			<label v-if="isValid && !name" class="error">Это поле обязательно</label>
		</div>
		<div class="form-control">
			<label for="password" class="form-label">Пароль</label>
			<input v-model="password" class="form-input" type="password" name="password" id="password" />
			<label v-if="isValid && password.length < 6" class="error">
				Минимальная длина пароля 6 символов
			</label>
		</div>
		<div class="form-control">
			<label for="confirm_password" class="form-label">Повтор пароля</label>
			<input
				v-model="confirm_password"
				class="form-input"
				type="password"
				name="confirm_password"
				id="confirm_password"
			/>
			<label v-if="isValid && password && password !== confirm_password" class="error">
				Пароли не совпадают
			</label>
		</div>
		<div class="form-control text-center">
			<div class="form-buttons">
				<div class="form-buttonsItem">
					<div class="button" @click="submit"><span>Зарегистрироваться</span></div>
				</div>
			</div>
			<div class="form-buttons">
				<div class="form-buttonsItem">
					<socials :im="false"></socials>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import socials from '@/components/socials.vue';

export default {
	components: { socials },
	data() {
		return {
			login: '',
			phone: '',
			name: '',
			password: '',
			confirm_password: '',
			isValid: false,
		};
	},
	computed: {
		valid() {
			return (
				this.login &&
				this.phone &&
				this.phone.length > 5 &&
				this.name &&
				this.password &&
				this.password.length >= 6 &&
				this.password === this.confirm_password &&
				this.idn &&
				this.domainAllowed
			);
		},
		idn() {
			var re = /^[-\w.]+@([А-яёA-z0-9][-А-яёA-z0-9]+\.)+[А-яёA-z]{2,6}$/;
			return re.test(this.login);
		},
		// список запрещённых доменов приходит с бэкенда при init (api/setBlockedEmailDomains)
		blockedDomains() {
			return this.$store.state.api.blockedEmailDomains || [];
		},
		domain() {
			return this.login.includes('@') ? this.login.split('@').pop().toLowerCase() : '';
		},
		domainAllowed() {
			return !this.domain || !this.blockedDomains.includes(this.domain);
		},
	},
	methods: {
		submit() {
			this.isValid = true; //отображаем ошибки
			if (this.valid)
				this.$emit('submit', {
					login: this.login,
					phone: this.phone,
					name: this.name,
					password: this.password,
					confirm_password: this.confirm_password,
				});
		},
	},
	watch: {
		login() {
			this.login = this.login.toLowerCase();
		},
	},
};
</script>
